module.exports = __webpack_public_path__ + "img/lounge_hover_6b78c73.png";